import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionTrabajadorCuentaPropiaByID = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionTrabajadorCuentaPropiaByID = () => {
  const [loadingGetDeclaracionTrabajadorCuentaPropiaByID, setLoadingDeclaracionTrabajadorCuentaPropiaByID] = useState(false);
  const [successGetDeclaracionTrabajadorCuentaPropiaByID, setSuccessDeclaracionTrabajadorCuentaPropiaByID] = useState(false);
  const [errorGetDeclaracionTrabajadorCuentaPropiaByID, setErrorDeclaracionTrabajadorCuentaPropiaByID] = useState<any>(null);
  const [dataGetDeclaracionTrabajadorCuentaPropiaByID, setDataDeclaracionTrabajadorCuentaPropia] = useState<any>(null);

  const [statusGetDeclaracionTrabajadorCuentaPropiaByID, setStatusGetDeclaracionTrabajadorCuentaPropiaByID] =
    useState<StatusGetDeclaracionTrabajadorCuentaPropiaByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionTrabajadorCuentaPropiaByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingDeclaracionTrabajadorCuentaPropiaByID(true);
    setSuccessDeclaracionTrabajadorCuentaPropiaByID(false);
    setErrorDeclaracionTrabajadorCuentaPropiaByID(null);

    try {
      const res = await apiRecord.getDeclaracionTrabajadorCuentaPropiaByID(
        userId,
        prestacionId,
        id
      );

      setStatusGetDeclaracionTrabajadorCuentaPropiaByID({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessDeclaracionTrabajadorCuentaPropiaByID(true);
      setDataDeclaracionTrabajadorCuentaPropia(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetDeclaracionTrabajadorCuentaPropiaByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorDeclaracionTrabajadorCuentaPropiaByID(err);
      console.error("Error en getDeclaracionTrabajadorCuentaPropiaByID:", err);

      throw err;

    } finally {
      setLoadingDeclaracionTrabajadorCuentaPropiaByID(false);
    }
  };

  return {
    getDeclaracionTrabajadorCuentaPropiaByID,
    loadingGetDeclaracionTrabajadorCuentaPropiaByID,
    successGetDeclaracionTrabajadorCuentaPropiaByID,
    errorGetDeclaracionTrabajadorCuentaPropiaByID,
    dataGetDeclaracionTrabajadorCuentaPropiaByID,
    statusGetDeclaracionTrabajadorCuentaPropiaByID
  };
};

export default useGetDeclaracionTrabajadorCuentaPropiaByID;
